module.exports = __webpack_public_path__ + "static/media/blueVert.6615deed.png";